import { Dialog } from "primereact/dialog";
import React from "react";
import { useTranslation } from "react-i18next";
import "./TermsAndConditionsPopup.scss";
import TermsAndConditions from "src/pages/TermsAndConditions/TermsAndConditions";

interface TermsAndConditionsPopupProps {
  isTermsAndConditionsPopupOpen: boolean;
  setIsTermsAndConditionsPopupOpen: (isOpen: boolean) => void;
}

const TermsAndConditionsPopup: React.FC<TermsAndConditionsPopupProps> = ({
  isTermsAndConditionsPopupOpen,
  setIsTermsAndConditionsPopupOpen,
}) => {
  const { t } = useTranslation(["common"]);
  const closePopup = () => {
    setIsTermsAndConditionsPopupOpen(false);
  };
  return (
    <Dialog
      visible={isTermsAndConditionsPopupOpen}
      onHide={closePopup}
      header={t("termsAndConditions")}
      headerClassName="popup-header"
      className="maintenance-requests-details-popup"
    >
      <TermsAndConditions />
    </Dialog>
  );
};

export default TermsAndConditionsPopup;
